import React, { useEffect, useState } from "react";
import { Col, Row, Card } from "antd";
import InfoMenu from "../components/InfoMenu";
import BusableWidget, { VIEW_BY_LINK } from "../components/BusableWidget";
const Image1 = require("../assets/original/_DA_8983_low_res.jpg");

export default function OgdensWestern() {
    const [activeLink, setActiveLink] = useState("tripPlanner");

    useEffect(() => {
        document.body.classList.add("PageOgdensWestern");
        return () => {
            document.body.classList.remove("PageOgdensWestern");
        };
    }, []);

    return (
        <div className="OgdensWestern PageSingle" style={{ paddingBottom: "50px" }}>
            <section
                className="PageHero Cover"
                style={{ backgroundImage: `url(${Image1})` }}
            >
                <div className="AppContainer">
                    <h1 className="title" style={{ marginBottom: "8px" }}>
                        Ogdens Western
                    </h1>
                    <h2 className="title" style={{ marginBottom: "0" }}>
                        Gilgandra | Gulargambone | Trangie
                    </h2>
                    <InfoMenu activeLink={activeLink} setActiveLink={setActiveLink} />
                </div>
            </section>
            <div className="AppContainer">
                <Row gutter={[20, 0]}>
                    <Col xs={{ span: 24, order: 1 }} md={{ span: 24, order: 1 }}>
                        <Card bordered={false} className="CardEmbed">
                            <BusableWidget
                                operatorId="ogdens_western"
                                view={VIEW_BY_LINK[activeLink]}
                                search={window.location.search}
                            />
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
